import { lerp } from '@immutabl3/utils';
import { restrictScrollPrecision } from '../utils/index.js';

export default function ScrollLerp() {
  let current = 0;

  const scrollLerp = function(target, alpha) {
    if (alpha === 0) return (current = target);

    const dest = lerp(current, target, alpha);
    return (current = restrictScrollPrecision(current, dest));
  };

  scrollLerp.get = () => current;
  scrollLerp.set = (target = 0) => (current = target);

  return scrollLerp;
};